import { UPDATE_FILTER, ADD_PRO, REMOVE_PRO } from './../constants/index';
import { PositionState } from './../types/logInTypes';
import {
	ALLOW_LOCATION,
	GET_LOCATION,
	GET_USER,
	SET_MYWALKS_URL,
	REMOVE_USER, 
	SET_TEAM, 
	SET_VIEW,
	SET_LANGUAGE
} from '../constants/index'
import Api from '../../services/Api'
import { sendStoreUpdate, storeType } from '../../helpers/shop_helper';
import store from '../store'

const api = Api.getInstance();

export const getUser = (payload: any) => {
	return {
		type: GET_USER,
		payload
	}
}

export const removeUser = () => {
	return {
		type: REMOVE_USER,
		payload: true
	}
}

export const getLocation = (payload: PositionState) => {
	api.post('position/save', payload).then(res => {
		if(res.ok){
			res.json().then(resJson => {
				if (resJson.status === 'ok') {
	
				} else {
					// console.log('Failed geolocation')
				}
			})
		}
	});

	return {
		type: GET_LOCATION,
		payload
	}
}

export const allowLocation = (payload: boolean) => {
	return {
		type: ALLOW_LOCATION,
		payload
	}
}

export const setMyWalksURL = (payload: any) => {
	return {
		type: SET_MYWALKS_URL,
		payload
	}
}

export const setView = (payload: string) => {
	return {
		type: SET_VIEW,
		payload
	}
}

export const setTeam = (payload: any) => {
	return {
		type: SET_TEAM,
		payload
	}
}

export const setLanguage = (payload: string) => {
	return {
		type: SET_LANGUAGE,
		payload
	}
}

export const updateFilter = (payload: any) => {
	return {
		type: UPDATE_FILTER,
		payload
	}
}

export const addPro = (payload: boolean) => {
	// console.log('addpro:', payload)
	return {
		type: ADD_PRO,
		payload
	}
}

export const addProBackend = () => {
	sendStoreUpdate(3, storeType(), null).then((res) => {
		// console.log('addprobackend', res)
		if(res === true) {
			store.dispatch(addPro(true))
		} else {
			// console.log('Could not add Pro')
		}
	//   goToPage('/walk/shop/success')
	})

}

const removePro = (payload: boolean) => {
	return {
		type: REMOVE_PRO,
		payload
	}
}

export const removeProBackend = (id: number) => {
	api.get('/purchase/delete/' + id)
	.then(res => res.json())
	.then(data => {
		if(data.status === 'ok'){ 
			store.dispatch(removePro(true)) 
		} else {
			// console.log('Could not remove purchase')
		}
	})
}